<div class="d-flex">
  <div class="link-cls pr-3">
    <p class="m-0">
      <a (click)="login()" (keydown.enter)="login()" tabindex="0" class="m-0">
        {{"homePageHeader.signIn"|cxTranslate}}
        <strong><img src="/images_and_icons/right-arrow.svg" alt="Right Arrow" /></strong>
      </a>
    </p>
  </div>
  <div class="link-cls">
    <p class="m-0">
      <a href="/request-access" class="m-0">
        {{"homePageHeader.requestAccess"|cxTranslate}}
        <strong><img src="/images_and_icons/right-arrow.svg" alt="Right Arrow" /></strong>
      </a>
    </p>
  </div>
</div>